import { render } from "./RedirectSelectMoment.vue?vue&type=template&id=065b4bb2"
import script from "./RedirectSelectMoment.vue?vue&type=script&lang=js"
export * from "./RedirectSelectMoment.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matalem/system/radioaconcagua/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__